"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.wrapRootElement = exports.onRouteUpdateDelayed = exports.onInitialClientRender = void 0;
var _converge = require("@seeka-labs/converge");
var _convergeReact = require("@seeka-labs/converge-react");
var _react = _interopRequireDefault(require("react"));
// eslint-disable @typescript-eslint/no-var-requires

// const rIC =
//     typeof requestIdleCallback !== "undefined" ? requestIdleCallback : setTimeout

// export const onRouteUpdate = ({ location, prevLocation }: RouteUpdateArgs, pluginOptions = {}) => {
//     rIC(() => {
//         (window.Converge as ConvergeSdk | undefined)?.hooks?.onRouteChange();
//     })
// }

var onInitialClientRender = exports.onInitialClientRender = function onInitialClientRender(_, pluginOptions) {
  (0, _convergeReact.initialiseSeekaProvider)({
    hosts: pluginOptions.hosts,
    id: pluginOptions.id,
    publicKey: pluginOptions.publicKey,
    org: pluginOptions.org,
    waitForInteraction: pluginOptions.waitForInteraction
  });
  // rIC(() => {
  //     window.Converge?.track.viewPage()
  // })
};
var onRouteUpdateDelayed = exports.onRouteUpdateDelayed = function onRouteUpdateDelayed(_ref) {
  var location = _ref.location;
  var sdk = window.Converge || undefined;
  if (sdk && sdk.hooks) {
    sdk.hooks.onRouteChange(location);
  }
};

// const loadConfig = (pluginOptions: PluginOptions): ConvergeSdkConfiguration | undefined => {
//     if (pluginOptions.url && pluginOptions.sdk) {
//         console.error('Seeka - Gatsby - url and sdk options are provided, only one should be provided. Using URL.')
//     }
//     if (pluginOptions.url && (pluginOptions.publicKey || pluginOptions.org)) {
//         console.error('Seeka - Gatsby - url, publicKey and/or org is provided, either URL or org and publicKey should be provided. Using URL.')
//     }

//     const hasUrlParams = pluginOptions.url ? true : (pluginOptions.publicKey && pluginOptions.org ? true : false)
//     const invalidConfig = !hasUrlParams && !pluginOptions.sdk;
//     if (invalidConfig) {
//         console.error('Seeka - Gatsby - no url, org and publicKey or sdk options provided')
//     }

//     let seekaConfig: ConvergeSdkConfiguration | undefined = undefined;
//     if (!hasUrlParams) {
//         seekaConfig = new ConvergeSdkConfiguration(pluginOptions.sdk.key,
//             pluginOptions.sdk.organisationId, {
//             analytics: { ...pluginOptions.sdk.tracking?.analytics },
//             processing: { ...pluginOptions.sdk.tracking?.processing },
//             debug: {
//                 isEnabled: pluginOptions.sdk?.debug?.isEnabled === true,
//             },
//             defaults: { ...pluginOptions.sdk.tracking?.defaults },
//         }, undefined, undefined, undefined, undefined, pluginOptions.sdk.scope.key, pluginOptions.sdk.scope.description);
//         // seekaConfig.scopeDescription = pluginOptions.sdk.scope.description;
//         // seekaConfig.scopeKey = pluginOptions.sdk.scope.key;
//         seekaConfig.plugins = [];
//         seekaConfig.debug = pluginOptions.sdk.debug;

//         if (pluginOptions.sdk.plugins && pluginOptions.sdk.plugins.length > 0) {
//             for (const plugin of pluginOptions.sdk.plugins) {
//                 const resolved = resolveSeekaPlugin(plugin);
//                 if (resolved) {
//                     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//                     (seekaConfig.plugins as any[]).push(resolved)
//                 }
//             }
//         }
//     }

//     return seekaConfig;
// }

var wrapRootElement = exports.wrapRootElement = function wrapRootElement(_ref2, pluginOptions) {
  var element = _ref2.element;
  // const config = loadConfig(pluginOptions);)

  if (typeof window !== 'undefined') {
    var _window$Seeka$context, _window$Seeka$context2, _window$Seeka$context3, _window$Seeka$context4, _window$Seeka$context5, _window$Seeka$context6, _window$Seeka$context7, _window$Seeka$context8, _window$Seeka$context9;
    if (!window.Seeka) window.Seeka = {};
    if (!window.Seeka.context) window.Seeka.context = {};
    if (!window.Seeka.client) {
      window.Seeka.client = {
        ver: "1.8.89",
        type: "js/@seeka-labs/gatsby-plugin-seeka"
      };
    }
    if (!window.Seeka.context.tracking) window.Seeka.context.tracking = window.Seeka.context.tracking || {};

    // Disable core OnRouteChange hook - Gatsby onRouteUpdateDelayed router will notify
    if (!((_window$Seeka$context = window.Seeka.context.tracking) !== null && _window$Seeka$context !== void 0 && _window$Seeka$context.processing)) window.Seeka.context.tracking.processing = {};
    if (!((_window$Seeka$context2 = window.Seeka.context.tracking) !== null && _window$Seeka$context2 !== void 0 && _window$Seeka$context2.processing.hooks)) window.Seeka.context.tracking.processing.hooks = {};
    if (!((_window$Seeka$context3 = window.Seeka.context.tracking) !== null && _window$Seeka$context3 !== void 0 && _window$Seeka$context3.processing.hooks.disabledListeners)) window.Seeka.context.tracking.processing.hooks.disabledListeners = [];
    var disabledListeners = window.Seeka.context.tracking.processing.hooks.disabledListeners;
    if (!disabledListeners.includes(_converge.HookListenerTypes.OnRouteChange)) {
      window.Seeka.context.tracking.processing.hooks.disabledListeners = [_converge.HookListenerTypes.OnRouteChange].concat(disabledListeners);
    }

    // Ensure auto page view tracking
    if (!((_window$Seeka$context4 = window.Seeka.context.tracking) !== null && _window$Seeka$context4 !== void 0 && _window$Seeka$context4.analytics)) window.Seeka.context.tracking.analytics = {};
    if (!((_window$Seeka$context5 = window.Seeka.context.tracking) !== null && _window$Seeka$context5 !== void 0 && (_window$Seeka$context6 = _window$Seeka$context5.analytics) !== null && _window$Seeka$context6 !== void 0 && _window$Seeka$context6.autoCollection)) window.Seeka.context.tracking.analytics.autoCollection = {};
    if (!((_window$Seeka$context7 = window.Seeka.context.tracking) !== null && _window$Seeka$context7 !== void 0 && (_window$Seeka$context8 = _window$Seeka$context7.analytics) !== null && _window$Seeka$context8 !== void 0 && (_window$Seeka$context9 = _window$Seeka$context8.autoCollection) !== null && _window$Seeka$context9 !== void 0 && _window$Seeka$context9.activityNames)) window.Seeka.context.tracking.analytics.autoCollection.activityNames = [];
    var autoActivityNames = window.Seeka.context.tracking.analytics.autoCollection.activityNames;
    if (!autoActivityNames.includes(_converge.TrackingActivityNames.ViewPage)) {
      window.Seeka.context.tracking.analytics.autoCollection.activityNames = [_converge.TrackingActivityNames.ViewPage].concat(autoActivityNames);
    }
    return (
      /*#__PURE__*/
      // <SeekaProvider config={config} url={pluginOptions.url} publicKey={pluginOptions.publicKey} org={pluginOptions.org}>
      _react.default.createElement(_convergeReact.SeekaProvider, {
        hosts: pluginOptions.hosts,
        id: pluginOptions.id,
        publicKey: pluginOptions.publicKey,
        org: pluginOptions.org,
        disableAutoInit: true,
        waitForInteraction: pluginOptions.waitForInteraction
      }, element)
    );
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element);
};

// const resolveSeekaPlugin = (plugin) => {
//     const pluginRef = plugin.resolve;
//     const packageName = pluginRef.replace('@seeka-labs/', '');
//     let instance;
//     try {
//         instance = require(/* webpackMode: "lazy", webpackChunkName: 'seeka-plugins' */ `./dist/plugins/${packageName}/dist/lib/${packageName}.module.js`);
//     }
//     catch (e) {
//         console.log('Seeka plugin load failed', e)
//         throw e;
//     }

//     if (!plugin) {
//         console.error(`Could not resolve Seeka plugin ${plugin.resolve}. Ensure the NPM package is is supported by @seeka-labs/gatsby-plugin-seeka`);
//         return null;
//     }
//     const functionName = Object.keys(instance)[0] as string
//     const created = new instance[functionName](plugin.options);

//     return created
// }